export default __webpack_public_path__ + "static/news-section-food2-image-998217127313f5532bb3ee22c4f81d01.webp";